import { ISensorProperty } from "../interfaces/ISensorProperty";
import * as TimeUtils from "../utils/time";
import { IDB } from "./IDB";
import { TTable } from "./TTable";

export class SensorHistory {
	private readonly idb = new IDB<ISensorProperty>();
	private readonly tableName: TTable = "history";

	public async putBulk(items: ISensorProperty[], shipmentId: string, deviceId: string, sensorDBKey: string): Promise<void> {
		const values = items.filter(item => Boolean(item)).map(item => ({
			...{ id: SensorHistory.buildKey(shipmentId, deviceId, sensorDBKey, item.epoch as number) },
			...item,
		}));
		await this.idb.putBulkValue(this.tableName, values);
	}

	public async getAll(shipmentId: string, deviceId: string, sensorDBKey: string, returnDate?: number, startTime?: number): Promise<ISensorProperty[]> {
		const lowerKey = SensorHistory.buildKey(shipmentId, deviceId, sensorDBKey, startTime || 0);
		const upperKey = SensorHistory.buildKey(shipmentId, deviceId, sensorDBKey, returnDate || TimeUtils.current());
		const query = IDBKeyRange.bound(lowerKey, upperKey);

		return await this.idb.getAll(this.tableName, query);
	}

	public async getAllKeys(shipmentId: string, deviceId: string, sensorDBKey: string): Promise<IDBValidKey[]> {
		const lowerKey = SensorHistory.buildKey(shipmentId, deviceId, sensorDBKey, 0);
		const upperKey = SensorHistory.buildKey(shipmentId, deviceId, sensorDBKey, TimeUtils.current());
		const query = IDBKeyRange.bound(lowerKey, upperKey);

		return await this.idb.getKeys(this.tableName, query);
	}

	public async delete(key: IDBKeyRange | IDBValidKey): Promise<void> {
		await this.idb.deleteValue(this.tableName, key);
	}

	public static buildKey(shipmentId: string, deviceId: string, sensorDBKey: string, epoch: number): string {
		return [shipmentId, deviceId, sensorDBKey, epoch].join("#");
	}

	public async clearObjectStore(): Promise<void> {
		await this.idb.clearObjectStore(this.tableName);
	}
}
